/* eslint-disable */
import { FormHelperText, Grid, InputLabel, Typography } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { withStyles } from '@material-ui/core/styles';
import FilterFramesIcon from '@material-ui/icons/FilterFrames';
import cn from 'classnames';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import { UI_POUR_METHOD_CHANGE } from '../../State/Store/UI/UI.types';
import themeCreateInjectableStyles from '../../Support/Theme/CreateInjectableStyles/ThemeCreateInjectableStyles.support';
import placeOrderStyles from './PlaceOrder.component.styles';

/**
 * PourMethod
 * @param {any} props The props
 * @returns {React.Component} The component
 */
const PourMethod = ({ actions, classes, defaultPourMethod, onChange = () => {}, isEdit, mandatoryFieldError }) => {
  const [pourMethod, setPourMethod] = useState(defaultPourMethod.selectedPourMethod ? defaultPourMethod.selectedPourMethod.code : ``);

  const pourMethods = {
    '2PMP': `2 Pumps`,
    BOOM: `Boom Pump`,
    CHUT: `Chute`,
    CRAN: `Crane & Kibble`,
    KERB: `Kerb`,
    L: `Line Pump`,
    WB: `Wheelbarrow`,
  };

  const pourMethodsCS08 = {
    '2PMP': `2 Pumps`,
    BUCK: `Bucket`,
    C: `Chute`,
    CHUT: `Chute`,
    COLM: `Columns`,
    CNCL: `Council Works`,
    CRAN: `Crane & Kibble`,
    ACCS: `Difficult Access`,
    XPLT: `Ex-Plant`,
    EXCA: `Excavator`,
    KERB: `Kerb`,
    HOLE: `Post Holes`,
    BFIL: `Blockfill Pump`,
    BOOM: `Boom Pump`,
    B: `Boom Pump`,
    LINE: `Line Pump`,
    L: `Line Pump`,
    SPRY: `Spray Pump`,
    WB: `Wheelbarrow`,
  };

  /**
   * Handles change in pour method
   * @param {Object} event event details
   * @returns {void} void
   * @memberof PlaceOrder
   */
  const pourMethodHandler = (event) => {
    actions.uiTriggered({
      payload: {
        data: {
          name: `placeOrderLeavePageYes`,
          value: event.target.value,
        },
      },
      type: UI_POUR_METHOD_CHANGE,
    });

    setPourMethod(event.target.value);
    onChange({ isValid: true, selectedPourMethod: { code: event.target.value, name: pourMethods[event.target.value] } });
    return;
  };

  return (
    <Grid container spacing={2} className={cn(classes.flexWrapNowrap)}>
      <Grid item xs={12}>
        <InputLabel className={cn(mandatoryFieldError ? classes.mandatoryFieldError : null, classes.inputLabel)}>Pour Method</InputLabel>
        <Select
          error={mandatoryFieldError}
          fullWidth
          id="pourMethod"
          name="pourMethod"
          disabled={isEdit}
          renderValue={(value) => {
            if (isEdit) {
              return (
                <React.Fragment>
                  <FilterFramesIcon className={classes.dropdownIcon} />
                  {pourMethodsCS08[pourMethod]}
                </React.Fragment>
              );
            }
            return pourMethod ? (
              <React.Fragment>
                <FilterFramesIcon className={classes.dropdownIcon} />
                {pourMethods[pourMethod]}
              </React.Fragment>
            ) : (
              <Typography variant="body1">
                <FilterFramesIcon className={classes.dropdownIcon} />
                <span className={classes.opacity05}>Pour Method</span>
              </Typography>
            );
          }}
          value={pourMethod || <FilterFramesIcon className={classes.dropdownIcon} />}
          onChange={pourMethodHandler}
        >
          {Object.keys(pourMethods).map((el, i) => {
            return (
              <MenuItem value={el} key={i}>
                <FilterFramesIcon className={classes.dropdownIcon} />
                {pourMethods[el]}
              </MenuItem>
            );
          })}
        </Select>
        {!isEdit && <FormHelperText className={cn(mandatoryFieldError ? classes.mandatoryFieldError : null, classes.inputLabel)}>Select how you will be pouring this concrete</FormHelperText>}
      </Grid>
    </Grid>
  );
};

/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/require-default-props */
PourMethod.propTypes = {
  actions: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  defaultPourMethod: PropTypes.object,
  onChange: PropTypes.func,
  isEdit: PropTypes.bool,
};

export default compose(
  connect(null, (dispatch) => ({
    actions: bindActionCreators(
      {
        ...uiActionCreators,
      },
      dispatch,
    ),
  })),
  withStyles(themeCreateInjectableStyles(placeOrderStyles), { withTheme: true }),
)(PourMethod);
